export default {
  'form.title': 'LISTADO DE FORMULARIOS',
  'config.searchForm': 'Buscar Formulario',
  'config.form.isInitialForm': '¿Formulario Inicial?',
  'config.form.isHeaderDetailsVisible': '¿Detalles de Cabecera Visible?',
  'config.form.isVisibleInDetails': '¿Visible en vista detalle de solicitud?',
};
